// Persist the SA-selected scheduling client across tab changes, nav, and page refresh.
const CLIENT_KEY = "scheduling.selectedClient"
const CLIENT_ID_KEY = "scheduling.selectedClientId"

export const loadPersistedClient = () => {
  try {
    const raw = localStorage.getItem(CLIENT_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export const loadPersistedClientId = () => {
  try {
    return localStorage.getItem(CLIENT_ID_KEY) || null
  } catch {
    return null
  }
}

export const persistClient = (client) => {
  try {
    if (client) localStorage.setItem(CLIENT_KEY, JSON.stringify(client))
    else localStorage.removeItem(CLIENT_KEY)
  } catch {
    /* storage unavailable — non-fatal */
  }
}

export const persistClientId = (id) => {
  try {
    if (id) localStorage.setItem(CLIENT_ID_KEY, String(id))
    else localStorage.removeItem(CLIENT_ID_KEY)
  } catch {
    /* storage unavailable — non-fatal */
  }
}
